import React, { Component } from 'react';
import { connect } from 'react-redux';
import TrailsApi from '../../../Logicas/TrailsApi';
import Loader from '../../utils/AutoPagination/Loader';

import * as S from './TrailCoursesManagerStyles';
import InfiniteScroll from 'react-infinite-scroller';
import DialogApi from '../../../Logicas/DialogApi';
import RemoveItemIco from '../../utils/img/delete-icon.svg';
import AddItemIco from '../../utils/img/add-icon.svg';

class TrailCoursesManager extends Component {
  constructor() {
    super();
    this.state = {
      // selectedCourses: null,
      selectedCourses: [],
      availableCourses: [],
      coursePage: 1,
      lastPageConcatenated: 0
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll() {
    const { getAllCourses, courseList } = this.props;
    const { coursePage } = this.state;

    if (!courseList || !courseList.courses || courseList.courses.length !== 10)
      return;

    getAllCourses(coursePage + 1);
    this.setState({ coursePage: coursePage + 1 });
  }

  componentDidMount() {
    const { trailId, getCurrentTrail, getAllCourses, page } = this.props;
    const { coursePage } = this.state;

    if (trailId) {
      getCurrentTrail(trailId);
    }

    getAllCourses(coursePage);

    const element = document.getElementById('scroll-trigger');

    if (!element) return;

    const observer = new IntersectionObserver((entries) => {
      const isIntersecting = entries.some((entry) => entry.isIntersecting);
      if (isIntersecting) this.handleScroll();
    });
    observer.observe(element);
  }

  componentDidUpdate(prevProps) {
    const {
      trailId,
      getCurrentTrail,
      currentTrailCourses,
      courseList
    } = this.props;
    const { lastPageConcatenated } = this.state;

    if (trailId && prevProps.trailId !== trailId) {
      getCurrentTrail(trailId);

      this.setState({
        selectedCourses: [],
        availableCourses: [],
        coursePage: 1,
        lastPageConcatenated: 0
      });

      return;
    }

    const { selectedCourses, availableCourses } = this.state;

    if (
      currentTrailCourses &&
      currentTrailCourses.trail_courses &&
      currentTrailCourses.trail_courses.length &&
      selectedCourses.length === 0 &&
      String(currentTrailCourses.trail.id) === String(trailId)
      // !selectedCourses
    )
      this.setState({ selectedCourses: currentTrailCourses.trail_courses });

    if (
      courseList &&
      courseList.pagination &&
      courseList.pagination.current_page &&
      courseList.pagination.current_page !== lastPageConcatenated &&
      courseList.courses &&
      courseList.courses.length
    ) {
      this.setState({
        availableCourses: availableCourses.concat(courseList.courses),
        lastPageConcatenated: courseList.pagination.current_page
      });
    }
  }

  render() {
    const { currentTrailCourses, courseList, coursesLoading } = this.props;
    const { selectedCourses, availableCourses } = this.state;

    const trailTagNames =
      currentTrailCourses &&
      currentTrailCourses.trail &&
      currentTrailCourses.trail.tags
        ? currentTrailCourses.trail.tags.map((tag) => tag.name.toLowerCase())
        : [];

    const trailCourseIds =
      (selectedCourses &&
        selectedCourses.map(
          (item) =>
            item.course && item.course.course_id && item.course.course_id
        )) ||
      [];

    const isAlreadyInTrail = (course) => {
      return trailCourseIds.includes(course.id);
    };

    const canAddCourseToTrail = (course) => {
      if (course.canBackToTrail) return true;
      if (!course.tags || course.tags.length === 0) return false;

      const courseTagNames = course.tags.map((tag) => tag.name.toLowerCase());

      // if (courseTagNames.includes('todos')) return true;

      return courseTagNames.some((tag) => trailTagNames.includes(tag));
    };

    const getRemovedAndAddedCourseIds = (availableCourses, selectedCourses) => [
      availableCourses.filter((item) => item.removed).map((item) => item.id),
      selectedCourses
        .filter((item) => item.course.added)
        .map((item) => item.course.course_id)
    ];

    const onCoursesChange = (availableCourses, selectedCourses) => {
      const coursesIds = getRemovedAndAddedCourseIds(
        availableCourses,
        selectedCourses
      );
      this.props.onCoursesChange(coursesIds);
    };

    const transformCourseToTrailCourse = (course) => ({
      course: { ...course, course_id: course.id, added: !course.removed }
    });

    const addCourseToTrail = (
      trailCourses,
      availableCourses,
      availableCourseIndex
    ) => {
      trailCourses.splice(
        trailCourses.length,
        0,
        transformCourseToTrailCourse(
          availableCourses.splice(availableCourseIndex, 1)[0]
        )
      );

      this.setState({ selectedCourses: trailCourses, availableCourses });
      onCoursesChange(availableCourses, trailCourses);
    };

    const transformTrailCourseToCourse = (trailCourse) => ({
      ...trailCourse.course,
      id: trailCourse.course.course_id,
      canBackToTrail: true,
      removed: !trailCourse.course.added
    });

    const removeCourseFromTrail = (
      trailCourses,
      availableCourses,
      trailCourseIndex
    ) => {
      availableCourses.splice(
        availableCourses.length,
        0,
        transformTrailCourseToCourse(
          trailCourses.splice(trailCourseIndex, 1)[0]
        )
      );

      this.setState({ selectedCourses: trailCourses, availableCourses });
      onCoursesChange(availableCourses, trailCourses);
    };

    return (
      <div
        style={{
          display: 'flex',
          fontFamily: 'Rubik'
        }}
      >
        <S.CourseTrailContainer>
          <span style={{ fontSize: '18px', fontWeight: '600' }}>
            Cursos selecionados
          </span>

          {(!selectedCourses || selectedCourses.length === 0) && (
            <div
              style={{
                marginTop: '2rem',
                padding: '1rem',
                textAlign: 'center',
                color: '#7A7A7A',
                fontSize: '14px'
              }}
            >
              Nenhum curso adicionado à trilha.
            </div>
          )}
          {selectedCourses &&
            selectedCourses.length > 0 &&
            selectedCourses.map((item, selectedCourseIndex) => (
              <div
                key={`${item.course_id}@${selectedCourseIndex}`}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  background: '#F4F5F9',
                  borderRadius: '10px',
                  position: 'relative'
                }}
              >
                <img
                  style={{
                    width: '150px',
                    height: '100px',
                    borderRadius: '10px'
                  }}
                  src={item && item.course && item.course.image.url}
                  alt=""
                />

                {/* <S.AddButton
                  onClick={() =>
                    removeCourseFromTrail(
                      selectedCourses,
                      availableCourses,
                      selectedCourseIndex
                    )
                  }
                >
                  -
                </S.AddButton> */}

                <S.DeleteButton
                  onClick={() =>
                    removeCourseFromTrail(
                      selectedCourses,
                      availableCourses,
                      selectedCourseIndex
                    )
                  }
                >
                  <img src={RemoveItemIco} alt="Remover" />
                </S.DeleteButton>
                <S.CourseInfo>
                  <S.CourseTitle>
                    {item && item.course && item.course.title}
                  </S.CourseTitle>
                  <S.ModulesCount>
                    {item && item.course && item.course.modules_amount}{' '}
                    {item && item.course && item.course.modules_amount > 1
                      ? 'Módulos'
                      : 'Módulo'}
                  </S.ModulesCount>
                </S.CourseInfo>
              </div>
            ))}
        </S.CourseTrailContainer>

        <S.CourseAvailableContainer>
          <span style={{ fontSize: '18px', fontWeight: '600' }}>
            Cursos disponíveis
          </span>
          <S.CourseAvailableList>
            {availableCourses &&
              availableCourses.length > 0 &&
              availableCourses.map((course, availableCourseIndex) => {
                const isAllowed =
                  canAddCourseToTrail(course) &&
                  !isAlreadyInTrail(course) &&
                  course.available;

                return (
                  <S.CourseCard
                    isAllowed={isAllowed}
                    key={`${course.id}@${availableCourseIndex}`}
                    title={
                      isAllowed
                        ? ''
                        : 'Este curso não possui tags compatíveis com a trilha'
                    }
                  >
                    <S.ImageWrapper>
                      <S.AddButton
                        isAllowed={isAllowed}
                        onClick={() =>
                          isAllowed &&
                          addCourseToTrail(
                            selectedCourses,
                            availableCourses,
                            availableCourseIndex
                          )
                        }
                      >
                        <img src={AddItemIco} alt="Adicionar" />
                      </S.AddButton>
                      <S.Image src={course.image.url} alt={course.title} />
                    </S.ImageWrapper>

                    <S.AvailableCourseInfo>
                      <S.AvailableCourseTitle>
                        {course.title}
                      </S.AvailableCourseTitle>
                      <S.AvailableModulesCount>
                        {course.modules_amount}{' '}
                        {course.modules_amount > 1 ? 'Módulos' : 'Módulo'}
                      </S.AvailableModulesCount>
                    </S.AvailableCourseInfo>
                  </S.CourseCard>
                );
              })}
          </S.CourseAvailableList>

          <div
            id="scroll-trigger"
            style={{
              margin: '0 auto',
              fontSize: '12px',
              textAlign: 'center',
              marginTop: '1rem',
              display:
                courseList &&
                courseList.courses &&
                courseList.courses.length === 10
                  ? 'block'
                  : 'none'
            }}
          ></div>
        </S.CourseAvailableContainer>
        <Loader loading={coursesLoading} />
        {/* <DialogAlert
            onClick={this.props.closeDialog}
            visible={this.props.alert.visible}
            message={this.props.alert.message}
          /> */}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getCurrentTrail: (id) => {
    dispatch(TrailsApi.getCurrentTrail(id));
  },
  getAllCourses: (page) => {
    dispatch(TrailsApi.getAllCourses(page));
  },
  openDialog: () => {
    dispatch(DialogApi.openDialog());
  },
  closeDialog: () => {
    dispatch(DialogApi.closeDialog());
  }
});

export default connect(
  (state) => ({
    currentTrailCourses: state.trails && state.trails.currentTrailCourses,
    courseList: state.trails && state.trails.courseList,
    coursesLoading: state.trails && state.trails.coursesLoading,
    alert: state.dialog
  }),
  mapDispatchToProps
)(TrailCoursesManager);
